import { ScholarshipAwardDurationDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadScholarshipAwardDuration = createAction(
  '[ScholarshipAwardDuration] Load ScholarshipAwardDuration'
);

export const loadScholarshipAwardDurationSuccess = createAction(
  '[ScholarshipAwardDuration] Load ScholarshipAwardDuration Success',
  props<{ scholarshipAwardDuration: ScholarshipAwardDurationDto[] }>()
);

export const loadScholarshipAwardDurationFailure = createAction(
  '[ScholarshipAwardDuration] Load ScholarshipAwardDuration Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addScholarshipAwardDuration = createAction(
  '[ScholarshipAwardDuration] Add ScholarshipAwardDuration',
  props<{ newScholarshipAwardDuration: ScholarshipAwardDurationDto[] }>()
);

export const addScholarshipAwardDurationSuccess = createAction(
  '[ScholarshipAwardDuration] Add ScholarshipAwardDuration Success',
  props<{ newScholarshipAwardDuration: ScholarshipAwardDurationDto[] }>()
);

export const addScholarshipAwardDurationFailure = createAction(
  '[ScholarshipAwardDuration] Add ScholarshipAwardDuration Failure',
  props<{ error: any }>()
);

/**
 * Update ScholarshipAwardDuration Collection Actions
 */
export const updateScholarshipAwardDuration = createAction(
  '[ScholarshipAwardDuration] Update ScholarshipAwardDuration',
  props<{ updateScholarshipAwardDuration: ScholarshipAwardDurationDto[] }>()
);

export const updateScholarshipAwardDurationSuccess = createAction(
  '[ScholarshipAwardDuration] Update ScholarshipAwardDuration Success',
  props<{ updateScholarshipAwardDuration: ScholarshipAwardDurationDto[] }>()
);

export const updateScholarshipAwardDurationFailure = createAction(
  '[ScholarshipAwardDuration] Update ScholarshipAwardDuration Failure',
  props<{ error: any }>()
);

/**
 * Remove ScholarshipAwardDuration Collection Actions
 */
export const removeScholarshipAwardDuration = createAction(
  '[ScholarshipAwardDuration] Remove ScholarshipAwardDuration',
  props<{ ids: string[] }>()
);

export const removeScholarshipAwardDurationSuccess = createAction(
  '[ScholarshipAwardDuration] Remove ScholarshipAwardDuration Success',
  props<{ ids: string[] }>()
);

export const removeScholarshipAwardDurationFailure = createAction(
  '[ScholarshipAwardDuration] Remove ScholarshipAwardDuration Failure',
  props<{ error: any }>()
);
